module.exports = __webpack_public_path__ + "img/abt-3.d2763497.png";